import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authorizedGuard } from 'src/app/shared/guards/authorized.guard';
import { LicensesComponent } from './pages/licenses/licenses.component';
import { OrderLicensesComponent } from './pages/order-licenses/order-licenses.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [authorizedGuard],
    component: LicensesComponent,
    data: { parent: 'more', parentFromRoot: true, animation: 'licenses' }
  },
  {
    path: 'order',
    canActivate: [authorizedGuard],
    component: OrderLicensesComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicensesRoutingModule { }
